"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../hooks");
var _utils = require("./utils");
var _CustomFieldsOptions = require("./CustomFieldsOptions");
var _CustomFieldsConditionsEditor = require("./CustomFieldsConditionsEditor");
var _ToggleButton = require("./ToggleButton");
var _filters = require("../config/filters");
var _hooks2 = require("./hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "custom-fields-filter": "custom-fields-filter_39Xel7",
  "customFieldsFilter": "custom-fields-filter_39Xel7"
}; 
require('./CustomFieldsFilter.css');
const DROPDOWN_ID = 'custom-fields-dropdown';
const CustomFieldsFilter = ({
  value,
  onChange
}) => {
  var _useContext;
  const [currentFilters, setCurrentFilters] = (0, _react.useState)();
  const fields = (_useContext = (0, _react.useContext)(_hooks.FacetsContext)) === null || _useContext === void 0 || (_useContext = _useContext.facets) === null || _useContext === void 0 ? void 0 : _useContext.fields;
  const appliedFilters = (0, _hooks2.useAppliedFilters)(value, fields);
  const options = (0, _hooks2.useCustomFieldOptions)(fields);
  const targetFilters = currentFilters !== null && currentFilters !== void 0 ? currentFilters : appliedFilters;
  const applyFilters = (0, _react.useCallback)(() => {
    if (!currentFilters) {
      return;
    }

    // clean currentFilters so they can be recalculated
    setCurrentFilters(null);
    const currentFilteredFilters = currentFilters.filter(_utils.filterHasNoEmptyConditions);
    const currentCustomFilters = (0, _utils.toCustomFilterItems)(currentFilteredFilters);
    const filtersHaveChanged = !(0, _utils.customFiltersItemsAreEquals)(currentCustomFilters, value);
    if (filtersHaveChanged) {
      onChange(currentCustomFilters);
    }
  }, [currentFilters, value, onChange]);
  const {
    handleBlur,
    handleKeyDown,
    isExpanded,
    isFocused,
    toggleDropdown,
    closeDropdown
  } = (0, _hooks2.useDropdown)({
    onBlur: applyFilters
  });
  const onCustomFieldSelect = (0, _react.useCallback)(customField => setCurrentFilters([{
    customField,
    operator: _filters.CUSTOM_FIELDS_OPERATORS_MAPPING[customField.dataType][0]
  }]), []);
  const onFiltersClear = (0, _react.useCallback)(() => {
    onChange === null || onChange === void 0 || onChange([]);
  }, [onChange]);
  const onFiltersApply = (0, _react.useCallback)(() => {
    applyFilters();
    closeDropdown();
  }, [applyFilters, closeDropdown]);
  const getButtonLabel = (0, _react.useCallback)(() => {
    if (!targetFilters || targetFilters.length === 0) {
      return 'Any custom field';
    }
    return targetFilters.length === 1 ? targetFilters[0].customField.displayName : `${targetFilters.length} custom fields`;
  }, [targetFilters]);
  if (options.length === 0) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      "data-test-id": "custom-fields-filter",
      className: styles.customFieldsFilter,
      id: DROPDOWN_ID,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/_react.default.createElement(_ToggleButton.ToggleButton, {
      label: getButtonLabel(),
      active: !!(targetFilters !== null && targetFilters !== void 0 && targetFilters.length),
      expanded: isExpanded,
      controls: DROPDOWN_ID,
      isFocused: isFocused,
      onClick: toggleDropdown
    }), isExpanded && (targetFilters !== null && targetFilters !== void 0 && targetFilters.length ? /*#__PURE__*/_react.default.createElement(_CustomFieldsConditionsEditor.CustomFieldsConditionsEditor, {
      options: options,
      onChange: setCurrentFilters,
      onClear: onFiltersClear,
      onSubmit: onFiltersApply,
      value: targetFilters,
      id: DROPDOWN_ID
    }) : /*#__PURE__*/_react.default.createElement(_CustomFieldsOptions.CustomFieldsOptions, {
      options: options,
      onChange: onCustomFieldSelect,
      id: DROPDOWN_ID
    })))
  );
};
var _default = exports.default = CustomFieldsFilter;
//# sourceMappingURL=CustomFieldsFilter.js.map